var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "c-games" },
    [
      _vm.ua === "sp"
        ? _c("select-order", {
            attrs: {
              orderTypes: _vm.orderTypes,
              currentOrderType: _vm.orderType
            },
            on: { selectOrderType: _vm.onSelectOrderType }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "header",
        { staticClass: "c-games_gameListHeader" },
        [
          _c("game-list-header", {
            attrs: { appCount: _vm.sortedApps.length, loading: _vm.loading }
          }),
          _vm._v(" "),
          _vm.ua === "pc"
            ? _c("toggle-order", {
                attrs: {
                  orderTypes: _vm.orderTypes,
                  currentOrderType: _vm.orderType
                },
                on: { selectOrderType: _vm.onSelectOrderType }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "c-games_empty" }, [_vm._v("読み込み中")])
        : _c("GameList", { attrs: { apps: _vm.sortedApps, ua: _vm.ua } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34db6518", { render: render, staticRenderFns: staticRenderFns })
  }
}